import React, { useState } from 'react'
import { Form, Modal, Row, Col, Card, Space, Button, Badge, Avatar, Upload, Alert, Input, Select, Typography, message, Divider, Tag, Grid } from 'antd';
import { UserOutlined, EnvironmentOutlined, GlobalOutlined, EditOutlined, SafetyOutlined, ShopOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { COLOMBIA_DATA } from '../../../constants/colombiaData';
const { useBreakpoint } = Grid;
const { Title, Text } = Typography;

const SeccionPerfil = ({ session, updateUser }) => {

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [detallesVisibles, setDetallesVisibles] = useState(true);

  const [isModalUserOpen, setIsModalUserOpen] = useState(false);
  const [isModalDirOpen, setIsModalDirOpen] = useState(false);
  const [isModalRegOpen, setIsModalRegOpen] = useState(false);
  const [departamentoUsuarioActivo, setDepartamentoUsuarioActivo] = useState(null);
  const [avatarFileBase64, setAvatarFileBase64] = useState(null);

  const [formUser] = Form.useForm();
  const [formDir] = Form.useForm();
  const [formReg] = Form.useForm();

  const handleActualizarPerfil = async (values, seccion) => {
    try {
      message.loading(`Actualizando ${seccion}...`, 0);

      if (seccion === "Perfil de Usuario" && avatarFileBase64) {
        values.avatar_url = avatarFileBase64;
      }

      await updateUser(values);

      message.destroy();
      message.success(`${seccion} actualizado correctamente`);
      setIsModalUserOpen(false);
      setIsModalDirOpen(false);
      setIsModalRegOpen(false);
    } catch (error) {
      message.destroy();
      message.error("No se pudo actualizar la información");
    }
  };

  return (
    <div className="fade-in">
      <Card style={{ borderRadius: 12, marginBottom: 24, borderTop: '4px solid #22BABB' }}>
        {!isMobile ? (
          <Row gutter={24} align="middle">
            <Col>
              <Avatar
                size={100}
                icon={!session?.user?.avatar ? <UserOutlined /> : null}
                src={session?.user?.avatar}
                style={{ border: '2px solid #e2e8f0' }}
              />
            </Col>
            <Col flex="auto">
              <Title level={3} style={{ margin: 0 }}>{session?.user?.nombre} {session?.user?.apellidos || ''}</Title>
              <Space split={<Divider type="vertical" />}>
                <Text type="secondary"><SafetyOutlined />{session?.rol?.nombre === 'CEO' ? 'Superadministrador' : session?.rol?.nombre || 'No registrado'}</Text>

                <Text type="secondary" title="Nombre de la empresa"><ShopOutlined /> {session?.empresa?.nombre || 'No registrado'}</Text>
              </Space>
            </Col>
          </Row>
        ) : (
          <Row gutter={[12, 0]} align="middle" wrap={false} style={{ width: '100%' }}>
            <Col flex="none">
              <Avatar
                size={{ xs: 64, sm: 80, md: 100, lg: 100, xl: 100, xxl: 100 }}
                icon={!session?.user?.avatar ? <UserOutlined /> : null}
                src={session?.user?.avatar}
                style={{ border: '2px solid #e2e8f0' }}
              />
            </Col>

            <Col flex="auto" style={{ minWidth: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
                <Title
                  level={4}
                  style={{
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {session?.user?.nombre} {session?.user?.apellidos || ''}
                </Title>

                <Space
                  direction="vertical"
                  size={0}
                  style={{ width: '100%' }}
                >
                  <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                    <SafetyOutlined /> {session?.rol?.nombre === 'CEO' ? 'Superadmin' : session?.rol?.nombre || 'No registrado'}
                  </Text>

                  <Text
                    type="secondary"
                    style={{ fontSize: '12px', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    <ShopOutlined /> {session?.empresa?.nombre || 'No registrado'}
                  </Text>
                </Space>
              </div>
            </Col>
          </Row>
        )}
      </Card>

      <div className="fade-in">
        <Card
          title={<span style={{ fontSize: isMobile ? "15px" : "17px" }}><UserOutlined /> Información del Usuario</span>}
          extra={<Button type="link" icon={<EditOutlined />} onClick={() => setIsModalUserOpen(true)} title='Editar información'>Editar</Button>}
          style={{ borderRadius: 12, marginBottom: 24 }}
        >
          {!isMobile ? (
            <Row gutter={[16, 24]}>
              <Col span={12}><Text type="secondary">Nombres y Apellídos:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.nombre || 'No registrado'} {session?.user?.apellidos || ''}</Text></Col>
              <Col span={12}><Text type="secondary">Correo Electrónico:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.email || 'No registrado'}</Text></Col>
              <Col span={12}><Text type="secondary">Teléfono:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.telefono || 'No registrado'}</Text></Col>
            </Row>
          ) : (
            <>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Nombres y Apellídos:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.nombre || 'No registra'} {session?.user?.apellidos || ''}</Text>
              </Row>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Correo electrónico:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.email || 'No registrado'}</Text>
              </Row>
              <Row>
                <Text type="secondary">Teléfono:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.telefono || 'No registrado'}</Text>
              </Row>
            </>
          )}
        </Card>

        <Card
          title={<span style={{ fontSize: isMobile ? "15px" : "17px" }}> <EnvironmentOutlined />  Información de Residencia</span>}
          extra={<Button type="link" icon={<EditOutlined />} onClick={() => setIsModalDirOpen(true)} title='Editar información'>Editar</Button>}
          style={{ borderRadius: 12, marginBottom: 24 }}
        >
          {!isMobile ? (
            <Row gutter={[16, 24]}>
              <Col span={12}><Text type="secondary">País:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.pais || 'Colombia'}</Text></Col>
              <Col span={12}><Text type="secondary">Departamento:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.provincia || 'No registrado'}</Text></Col>
              <Col span={12}><Text type="secondary">Ciudad:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.ciudad || 'No registrada'}</Text></Col>
              <Col span={12}><Text type="secondary">Dirección:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.direccion || 'No registrada'}</Text></Col>
              <Col span={12}><Text type="secondary">Código postal:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.code_postal || '--------'}</Text></Col>
            </Row>
          ) : (
            <>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">País:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.pais || 'Colombia'}</Text>
              </Row>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Departamento:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.provincia || 'No registrado'}</Text>
              </Row>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Ciudad:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.ciudad || 'No registrada'}</Text>
              </Row>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Dirección:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.direccion || 'No registrada'}</Text>
              </Row>
              <Row>
                <Text type="secondary">Código postal:</Text> <Text strong style={{ marginLeft: 8 }}>{session?.user?.code_postal || '------'}</Text>
              </Row>
            </>
          )}
        </Card>

        <Card
          title={<span style={{ fontSize: isMobile ? "15px" : "17px" }}><GlobalOutlined /> Preferencias Regionales</span>}
          extra={<Button type="link" icon={<EditOutlined />} onClick={() => setIsModalRegOpen(true)} title='Editar información'>Editar</Button>}
          style={{ borderRadius: 12 }}
        >
          {!isMobile ? (
            <Row >
              <Col span={12}>
                <Text type="secondary">Idioma de la Interfaz: </Text>
                <Text strong style={{ display: 'block' }}>
                  {session?.user?.idioma === 'en' ? 'Inglés - English' : 'Español - Spanish'}
                </Text>
              </Col>
              <Col span={12}>
                <Text type="secondary">Zona Horaria Personal: </Text>
                <Text strong style={{ display: 'block' }}>
                  {session?.user?.zona_horaria === 'America/Bogota' ? '(GMT -5:0) Hora de Colombia' : session?.user?.zona_horaria || '(GMT -5:0) Hora de Colombia'}
                </Text>
              </Col>
            </Row>
          ) : (
            <>
              <Row style={{ marginBottom: '12px' }}>
                <Text type="secondary">Idioma de la Interfaz: </Text>
                <Text strong style={{ display: 'block' }}>
                  {session?.user?.idioma === 'en' ? 'Inglés - English' : 'Español - Spanish'}
                </Text>
              </Row>
              <Row>
                <Text type="secondary">Zona Horaria Personal: </Text>
                <Text strong style={{ display: 'block' }}>
                  {session?.user?.zona_horaria === 'America/Bogota' ? '(GMT -5:0) Hora de Colombia' : session?.user?.zona_horaria || '(GMT -5:0) Hora de Colombia'}
                </Text>
              </Row>
            </>
          )}
        </Card>
      </div>

      <Modal
        title={<Space><UserOutlined /> Editar Información Personal</Space>}
        open={isModalUserOpen}
        onCancel={() => {
          setIsModalUserOpen(false);
          formUser.resetFields();
          setAvatarFileBase64(null);
        }}
        onOk={() => formUser.submit()}
        okText="Guardar Cambios"
        okButtonProps={{ style: { backgroundColor: '#22BABB' } }}
      >
        <Form
          form={formUser}
          layout="vertical"
          onFinish={(v) => handleActualizarPerfil(v, "Perfil de Usuario")}
          style={{ marginTop: 20 }}
          initialValues={{
            nombre: session?.user?.nombre,
            apellidos: session?.user?.apellidos,
            email: session?.user?.email,
            telefono: session?.user?.telefono
          }}
        >
          <Row gutter={16}>
            <Col span={24} style={{ textAlign: 'center', marginBottom: 20 }}>
              <Upload
                showUploadList={false}
                beforeUpload={(file) => {
                  const reader = new FileReader();
                  reader.onload = (e) => setAvatarFileBase64(e.target.result);
                  reader.readAsDataURL(file);
                  return false;
                }}
              >
                <Badge count={<Button shape="circle" icon={<EditOutlined />} size="small" />} offset={[-10, 80]}>
                  <Avatar
                    size={100}
                    icon={!avatarFileBase64 && !session?.user?.avatar ? <UserOutlined /> : null}
                    src={avatarFileBase64 || session?.user?.avatar} // Muestra la nueva si hay, si no la de sesión
                    style={{ backgroundColor: '#f0f2f5', color: '#22BABB', cursor: 'pointer', border: '1px solid #d9d9d9' }}
                  />
                </Badge>
              </Upload>
              <Text type="secondary" style={{ display: 'block', marginTop: '10px', fontSize: '12px' }}>
                Haz clic en la imagen para cambiar tu foto (Max 2MB)
              </Text>
            </Col>

            <Col span={24}>
              <Alert message="El correo electrónico es tu credencial de acceso y no puede modificarse desde aquí." type="info" showIcon style={{ marginBottom: 20 }} />
            </Col>

            <Col span={12}><Form.Item name="nombre" label="Nombres" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="apellidos" label="Apellídos"><Input /></Form.Item></Col>
            <Col span={24}><Form.Item name="email" label="Correo Electrónico"><Input disabled prefix={<MailOutlined />} /></Form.Item></Col>
            <Col span={24}><Form.Item name="telefono" label="Teléfono"><Input prefix={<PhoneOutlined />} /></Form.Item></Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title={<Space><EnvironmentOutlined /> Editar Dirección de Residencia</Space>}
        open={isModalDirOpen}
        onCancel={() => {
          setIsModalDirOpen(false);
          formDir.resetFields();
          setDepartamentoUsuarioActivo(null);
        }}
        onOk={() => formDir.submit()}
        okText="Guardar Dirección"
        okButtonProps={{ style: { backgroundColor: '#22BABB' } }}
      >
        <Form
          form={formDir}
          layout="vertical"
          onFinish={(v) => handleActualizarPerfil(v, "Dirección Personal")}
          style={{ marginTop: 20 }}
          initialValues={{
            direccion: session?.user?.direccion,
            provincia: session?.user?.provincia,
            ciudad: session?.user?.ciudad,
            code_postal: session?.user?.code_postal,
            pais: session?.user?.pais || 'Colombia'
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="pais" label="País">
                <Select>
                  <Select.Option value="Colombia">Colombia</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="provincia" label="Departamento">
                <Select
                  showSearch
                  placeholder="Selecciona el departamento"
                  options={Object.keys(COLOMBIA_DATA).map(dpto => ({ label: dpto, value: dpto }))}
                  onChange={(valor) => {
                    setDepartamentoUsuarioActivo(valor);
                    formDir.setFieldsValue({ ciudad: undefined });
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="ciudad" label="Ciudad">
                <Select
                  showSearch
                  placeholder="Selecciona la ciudad"
                  disabled={!departamentoUsuarioActivo && !formDir.getFieldValue('provincia')}
                  options={
                    (COLOMBIA_DATA[departamentoUsuarioActivo || formDir.getFieldValue('provincia')] || []).map(ciudad => ({
                      label: ciudad,
                      value: ciudad
                    }))
                  }
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="code_postal" label="Código Postal">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="direccion" label="Dirección de Residencia">
                <Input prefix={<EnvironmentOutlined style={{ color: '#bfbfbf' }} />} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title={<Space><GlobalOutlined /> Preferencias Regionales</Space>}
        open={isModalRegOpen}
        onCancel={() => setIsModalRegOpen(false)}
        onOk={() => formReg.submit()}
        okText="Guardar Preferencias"
        okButtonProps={{ style: { backgroundColor: '#22BABB' } }}
      >
        <Form
          form={formReg}
          layout="vertical"
          onFinish={(v) => handleActualizarPerfil(v, "Preferencias Regionales")}
          style={{ marginTop: 20 }}
          initialValues={{
            idioma: session?.user?.idioma || 'es',
            zona_horaria: session?.user?.zona_horaria || 'America/Bogota'
          }}
        >
          <Form.Item name="idioma" label="Idioma de la Interfaz">
            <Select options={[
              { value: 'es', label: 'Español - Spanish' },
              { value: 'en', label: 'Inglés - English' }
            ]}
            />
          </Form.Item>
          <Form.Item name="zona_horaria" label="Zona Horaria Personal">
            <Select options={[
              { value: 'America/Bogota', label: '(GMT -5:0) Hora de Colombia' },
              { value: 'America/Mexico_City', label: '(GMT -6:0) Hora de México' },
              { value: 'America/Argentina/Buenos_Aires', label: '(GMT -3:0) Hora de Argentina' }
            ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SeccionPerfil